const productSearchExclusions = [
  '-tag:apple_care_care+',
  '-tag:apple_care',
  '-product_type:SecondWarranty',
  '-title:AppleCare',
];

function getVisibleProductSearchTerm(searchTerm) {
  return productSearchExclusions
    .reduce((visibleTerm, exclusion) => visibleTerm.replaceAll(exclusion, ''), searchTerm)
    .replace(/\s+/g, ' ')
    .trim();
}

function getProductSearchQuery(searchTerm) {
  const visibleTerm = getVisibleProductSearchTerm(searchTerm);

  if (!visibleTerm) return '';

  return `${visibleTerm} ${productSearchExclusions.join(' ')}`;
}

function normalizeProductSearchUrl() {
  const searchForm = document.querySelector('form[data-product-search]');

  if (!searchForm) return;

  const searchUrl = new URL(searchForm.action, window.location.origin);

  if (window.location.pathname !== searchUrl.pathname) return;

  const searchParams = new URLSearchParams(window.location.search);
  const currentQuery = searchParams.get('q');

  if (!currentQuery) return;

  const normalizedQuery = getProductSearchQuery(currentQuery);

  if (currentQuery === normalizedQuery && searchParams.get('type') === 'product') return;

  searchParams.set('q', normalizedQuery);
  searchParams.set('type', 'product');
  window.location.replace(`${searchUrl.pathname}?${searchParams.toString()}`);
}

document.addEventListener('formdata', (event) => {
  const form = event.target.closest('form[data-product-search]');

  if (!form) return;

  const searchTerm = event.formData.get('q');

  if (typeof searchTerm !== 'string') return;

  event.formData.set('q', getProductSearchQuery(searchTerm));
  event.formData.set('type', 'product');
});

normalizeProductSearchUrl();

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
